'use strict';

import {DebuggableObject} from './DebuggableObject.js';
import {Glossar} from './Glossar.js';
import {initializer} from './Initializer.js';

export class Component extends DebuggableObject {
    constructor(selector) {
        super();
        this.glossar = new Glossar(this.texts());
        selector && initializer.add(selector, (index, elm) => this.init(elm));
    }

    init() {
        throw new Error('no submit function present for ' + this.constructor.name);
    }

    texts() {
        return {};
    }

    text(name) {
        return this.glossar.getText(name);
    }

    html() {
        return `<h1>no content here</h1>`;
    }
}